(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arara-emotion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('arara-emotion')) {
  customElements.define('arara-emotion', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.ae__track');
      this.dialog = this.querySelector('dialog');
      if (!this.track || !this.dialog) return;
      this.mobile = matchMedia('(max-width:749px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.querySelectorAll('[data-ae-hotspot]').forEach(button => button.hidden = false);
      this.querySelector('.ae__arrows').hidden = false;
      this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.track.addEventListener('pointerdown', event => {
        if(event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button,a')) return;
        this.drag={id:event.pointerId,x:event.clientX,left:this.track.scrollLeft,moved:false};
      }, { signal });
      window.addEventListener('pointermove', event => {
        const drag=this.drag;
        if(!drag || event.pointerId!==drag.id)return;
        const distance=event.clientX-drag.x;
        if(!drag.moved && Math.abs(distance)<6)return;
        if(!drag.moved){drag.moved=true;this.close(false,true);this.track.classList.add('is-dragging');this.track.setPointerCapture(event.pointerId);}
        event.preventDefault();
        this.track.scrollLeft=drag.left-distance;
      }, { signal, passive:false });
      const finishDrag=()=>{
        const drag=this.drag;if(!drag)return;this.drag=null;
        if(this.track.hasPointerCapture(drag.id))this.track.releasePointerCapture(drag.id);
        this.track.classList.remove('is-dragging');
        if(drag.moved){this.suppressClickUntil=performance.now()+250;this.updateArrows();}
      };
      window.addEventListener('pointerup',finishDrag,{signal});
      window.addEventListener('pointercancel',finishDrag,{signal});
      window.addEventListener('blur',finishDrag,{signal});
      this.track.addEventListener('lostpointercapture',finishDrag,{signal});
      this.track.addEventListener('click',event=>{if(performance.now()<(this.suppressClickUntil||0)){event.preventDefault();event.stopImmediatePropagation();}},{signal,capture:true});
      this.addEventListener('click', event => {
        const hotspot = event.target.closest('[data-ae-hotspot]');
        if (hotspot && this.contains(hotspot)) { this.toggle(hotspot); return; }
        if (event.target.closest('[data-ae-close]')) this.close(true);
        if (event.target.closest('[data-ae-prev]')) this.move(-1);
        if (event.target.closest('[data-ae-next]')) this.move(1);
      }, { signal });
      document.addEventListener('pointerdown', event => {
        if (!this.active) return;
        if (event.target.closest('[data-ae-hotspot]')) return;
        if (!this.dialog.contains(event.target) || event.target === this.dialog) this.close(true);
      }, { signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.active) { event.preventDefault(); this.close(true); }
      }, { signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(true); }, { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); }
      }, { signal });
      this.track.addEventListener('scroll', () => { this.updateArrows(); if (this.active && !this.mobile.matches) this.close(false); }, { signal, passive:true });
      window.addEventListener('scroll', () => { if (this.active && !this.mobile.matches) this.close(false); }, { signal, passive:true });
      this.mobile.addEventListener('change', () => this.close(false, true), { signal });
      this.observer = new ResizeObserver(() => { this.updateArrows(); if(this.active && !this.mobile.matches) this.place(); });
      this.observer.observe(this.track);
      document.addEventListener('shopify:block:select', event => {
        const look = this.querySelector('[data-ae-look="' + CSS.escape(event.detail.blockId) + '"]');
        if(look) { this.close(false,true); this.track.scrollTo({left:look.offsetLeft-this.track.offsetLeft-parseFloat(getComputedStyle(this.track).paddingLeft),behavior:'instant'}); }
      }, { signal });
      this.updateArrows();
    }
    disconnectedCallback() { this.close(false,true); this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
    updateArrows() {
      const end = this.track.scrollWidth-this.track.clientWidth;
      this.querySelector('[data-ae-prev]').disabled=this.track.scrollLeft<=2;
      this.querySelector('[data-ae-next]').disabled=this.track.scrollLeft>=end-2;
      this.querySelector('.ae__arrows').hidden=end<=2;
    }
    move(direction) {
      this.close(false,true);
      const look=this.track.querySelector('.ae__look');
      if(!look)return;
      const step=look.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap);
      this.track.scrollBy({left:step*direction,behavior:this.reduced.matches?'instant':'smooth'});
    }
    toggle(button) {
      if(this.active===button){this.close(true);return;}
      document.querySelectorAll('arara-emotion').forEach(section=>{if(section!==this)section.close?.(false,true);});
      this.close(false,true);
      const template=document.getElementById(button.dataset.aeHotspot);
      if(!template)return;
      this.querySelector('[data-ae-content]').replaceChildren(template.content.cloneNode(true));
      this.active=button;
      button.setAttribute('aria-expanded','true');
      if(this.mobile.matches)this.dialog.showModal();else this.dialog.show();
      if(!this.mobile.matches)this.place();
      this.dialog.getBoundingClientRect();
      this.dialog.classList.add('is-visible');
      this.dialog.querySelector('a')?.focus({preventScroll:true});
    }
    place() {
      if(!this.active)return;
      const rect=this.active.getBoundingClientRect(), width=this.dialog.offsetWidth, height=this.dialog.offsetHeight;
      const vw=document.documentElement.clientWidth, vh=window.innerHeight;
      let left=rect.left+rect.width/2-width/2;
      let top=rect.top-height-10;
      if(top<12)top=rect.bottom+10;
      this.dialog.style.left=Math.max(12,Math.min(left,vw-width-12))+'px';
      this.dialog.style.top=Math.max(12,Math.min(top,vh-height-12))+'px';
    }
    close(restore=false,instant=false) {
      clearTimeout(this.timer);
      const button=this.active;
      button?.setAttribute('aria-expanded','false');
      this.active=null;
      if(!this.dialog?.open)return;
      this.dialog.classList.remove('is-visible');
      const finish=()=>{this.dialog.close();if(restore&&button?.isConnected)button.focus({preventScroll:true});};
      if(instant||this.reduced?.matches)finish();else this.timer=setTimeout(finish,this.mobile?.matches?280:200);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
